import React from 'react';
import {
  ServiceRequestFormContextValue,
  useServiceRequestFormContext,
} from './CustomHooks/ServiceRequestFormContext';
import ServiceRequestFormAsset from './ServiceRequestFormAsset/ServiceRequestFormAsset';
import ServiceRequestFormCategory from './ServiceRequestFormCategory/ServiceRequestFormCategory';
import ServiceRequestFormFaqs from './ServiceRequestFormFaqs/ServiceRequestFormFaqs';
import ServiceRequestFormIssueType from './ServiceRequestFormIssueType/ServiceRequestFormIssueType';
import ServiceRequestFormQuestion from './ServiceRequestFormQuestion/ServiceRequestFormQuestion';
import ServiceRequestFormReview from './ServiceRequestFormReview/ServiceRequestFormReview';
import ServiceRequestFormSuite from './ServiceRequestFormSuite/ServiceRequestFormSuite';
import ServiceRequestFormDetails from 'src/components/ServiceRequestForm/ServiceRequestFormDetails/ServiceRequestFormDetails';
import { ServiceRequestFormStep } from './CustomHooks/serviceRequestFormSteps';

const ServiceRequestFormSteps = () => {
  const { step, reference }: ServiceRequestFormContextValue =
    useServiceRequestFormContext();

  switch (step) {
    case ServiceRequestFormStep.Suite:
      return (
        <ServiceRequestFormSuite
          isLoadingOptions={reference.isLoadingFormOptions}
          optionsError={reference.formOptionsError}
        />
      );
    case ServiceRequestFormStep.Asset:
      return <ServiceRequestFormAsset />;
    case ServiceRequestFormStep.IssueType:
      return <ServiceRequestFormIssueType />;
    case ServiceRequestFormStep.Category:
      return <ServiceRequestFormCategory />;
    case ServiceRequestFormStep.Faqs:
      return <ServiceRequestFormFaqs />;
    case ServiceRequestFormStep.Question:
      return <ServiceRequestFormQuestion />;
    case ServiceRequestFormStep.Details:
      return <ServiceRequestFormDetails />;
    case ServiceRequestFormStep.Review:
      return <ServiceRequestFormReview />;
    default:
      return null;
  }
};

export default ServiceRequestFormSteps;
